
import BScroll from '@better-scroll/core'
import { sleep } from '@/utils/validate'
import { deepClone } from '@/utils'

export default {
	props: {
		goodsDetail: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		// 选中的id数组
		currentFilterIds() {
			return this.currentFilter.map(item => item.id)
		}
	},
	data() {
		return {
			// 全部数据
			metadataModelResource: {
				components: [],
				resources: []
			},
			backFilledResources: {},
			lastDisplayFilter: null,
			displayFilter: [],
			// 显示层级
			components: {},
			// 选中项
			currentFilter: [],
			currenData: []
		}
	},
	mounted() {
		if (process.client) {
			this.metadataModelResource = this.goodsDetail.metadataModel
			// 首次默认选中第一个
			this.getFirstFilter(this.metadataModelResource.components)
			// resources 填充
			const deep = deepClone(this.metadataModelResource.components)
			this.backFilledResources = this.backFillResources(deep)
			// 初始化数据
			this.displayFilter = this.getDisplayFilter()
			// 皮肤数据
			this.lastDisplayFilter = this.currentFilter[this.currentFilter.length - 1]
			// 加载 bs
			this.createNewScroll()
		}
	},
	beforeDestroy() {
		if (!this.lastDisplayFilter?.children) return
		!this.column &&
			this.lastDisplayFilter?.children.forEach(item => {
				this[`scroll${item.id}`]?.destroy()
			})
	},
	methods: {
		/**
		 * 筛选后的结果，每次取的都是第一个值
		 */
		getDisplayFilter() {
			const copy = [...this.currentFilter]
			return [
				{
					children: this.backFilledResources,
					id: 0
				},
				...copy.splice(0, copy.length - 1 || [])
			]
		},
		/**
		 * 根据游戏 code 获取当前角色所属图片等
		 * @param {*} optionArr
		 */
		backFillResources(optionArr) {
			const resources = this.metadataModelResource.resources
			optionArr.forEach(item => {
				if (item.children && !item.resources.length) {
					this.backFillResources(item.children)
				} else {
					// 保持原本顺序
					const resourceCodes = item.resources
					item.resources = resourceCodes.map(code => resources.find(rsc => rsc.code === code))
				}
			})
			return optionArr
		},
		/**
		 * 首次默认选中第一个
		 * @param {*} currLevelArr
		 * @param {*} start
		 */
		getFirstFilter(currLevelArr, start = 0) {
			if (currLevelArr.length && currLevelArr[0].children && !currLevelArr[0].resources.length) {
				this.currentFilter[start] = currLevelArr[0]
				this.getFirstFilter(currLevelArr[0].children, start + 1)
			}
		},
		goToElementTop() {
			this.$nextTick(() => {
				const el = document?.querySelector('.fixed-pt')
				el &&
					el.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					})
			})
		},
		/**
		 * 点击筛选
		 * @param {*} opt
		 * @param {*} index
		 */
		onSelectLevel(opt, index) {
			if (opt.imageStyle) return
			this.currentFilter.splice(index, this.currentFilter.length - index, opt)
			if (opt.children) {
				this.getFirstFilter(opt.children, index + 1)
				this.displayFilter = this.getDisplayFilter() // 更新 displayFilter
				this.lastDisplayFilter = this.currentFilter[this.currentFilter.length - 1] // 更新 lastDisplayFilter
				// 设置新的 bs
				this.createNewScroll(true)
			}
			this.goToElementTop()
		},
		/**
		 * 创建新的 bs 插件
		 * @param {*} refresh 是否重新加载
		 */
		async createNewScroll(refresh = false) {
			if (!this.lastDisplayFilter?.children) return
			this.$nextTick(() => {
				!this.column &&
					this.lastDisplayFilter?.children.forEach(item => {
						this.initScroll(`scroll${item.id}`, refresh)
					})
			})
		},
		/**
		 * 初始化 bs 插件
		 * @param {*} refName 组件名
		 * @param {*} refresh 是否重新加载
		 */
		async initScroll(refName, refresh = false) {
			if (!this.$refs[refName]) return
			// 添加[0]以访问正确的元素
			this[refName] = new BScroll(this.$refs[refName][0], {
				// bounceTime: 100,
				scrollX: true,
				click: true,
				probeType: 3
			})
			// this[refName].on('scrollEnd', () => {
			// 	console.log('scrollingEnd')
			// })
			await sleep(30)
			refresh && this[refName].refresh()
		}
	}
}
